import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIClient } from '../../../helpers/ApiHelper';
import { saveAs } from 'file-saver';

export const downloadReport = createAsyncThunk(
    'downloadReport',
    async ({ audienceId }, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.getBlob(`/api/v1/analytic/audience/${audienceId}/report/download`, { responseType: 'blob' });
            saveAs(response, `AI_Report.pdf`);

            return { success: true, message: "Report downloaded successfully." };
        } catch (error) {
            return thunkAPI.rejectWithValue({ success: false, message: "Failed to download the report." });
        }
    }
);

export const reportDownloadSlice = createSlice({
    name: 'downloadReport',
    initialState: {
        loading: true,
        data: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(downloadReport.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(downloadReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
            
        });
        builder.addCase(downloadReport.rejected, (state, action) => {
            state.loading = false;
            state.data = null;
            state.error = action.error.message; 
        });
    },
});

export default reportDownloadSlice.reducer;


